// Revyniqx SalesPro Brand Configuration

export const BRAND = {
  // Primary Product Name
  productName: "Revyniqx SalesPro",
  productTagline: "Voice-Based Sales Conversation Practice",
  
  // Platform
  platformName: "Revyniqx",
  
  // Company
  companyName: "K2B Learning Pvt. Ltd.",
  
  // Full Attribution
  poweredBy: "Powered by Revyniqx",
  companyAttribution: "A K2B Learning Company",
  
  // Product Positioning
  positioning: {
    headline: "Practice. Improve. Perform.",
    subheadline: "Conversation Intelligence for Sales Teams",
    description: "AI-powered voice practice platform that helps sales teams master real customer conversations",
  },
  
  // Terminology (updated from generic)
  terms: {
    readinessScore: "Conversation Readiness Score",
    sessions: "Practice Sessions",
    coaching: "Coaching Insights",
    feedback: "Performance Analysis",
    teamDashboard: "Team Readiness",
    repPerformance: "Rep Performance",
    scenarios: "Practice Scenarios",
    evaluation: "Coaching Report",
    strengths: "What You Did Well",
    improvements: "Areas to Improve",
    suggestions: "Coaching Recommendations",
  },
  
  // Colors (from brand guidelines)
  colors: {
    navy: "#0B1F3B",
    blue: "#2563EB",
    teal: "#14B8A6",
    orange: "#F59E0B",
    background: "#F8FAFC",
    textPrimary: "#0F172A",
    textSecondary: "#64748B",
    border: "#E2E8F0",
  },
  
  // Logo URL
  logoUrl: "https://customer-assets.emergentagent.com/job_pitch-confidence-lab/artifacts/x2bnctf3_REVYNIQX_TM-01.png",
};

// Brand-aware copy helpers
export const getCopy = {
  readinessMessage: (score) => {
    if (score >= 80) return `You are ${score}% ready for real customer conversations`;
    if (score >= 60) return `You're at ${score}% readiness. A few more practice sessions will sharpen your skills`;
    return `Your readiness is at ${score}%. Focus on the coaching insights to improve`;
  },
  
  improvementMessage: (improvement) => {
    if (improvement > 0) return `+${improvement}% improvement from your last session`;
    if (improvement < 0) return `${improvement}% — Let's get back on track`;
    return "Consistent performance";
  },
  
  classificationMessage: (classification) => {
    switch (classification) {
      case "field-ready": return "Ready for Real Conversations";
      case "needs-coaching": return "Keep Practicing";
      default: return "More Practice Needed";
    }
  },
};

export default BRAND;
